// ** Initial State
const initialState = {
    countryOption: [],
    cityOption: [],
    languageOption: [],
    guideTypeOption: []
  }
  
  const commonDataReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'GET_COUNTRY':
        return { ...state, countryOption: action.data }
      case 'GET_CITY':
        return { ...state, cityOption: action.data }
      case 'GET_LANGUAGE':
        return { ...state, languageOption: action.data }
      case 'GET_GUIDETYPE':
        return { ...state, guideTypeOption: action.data }
      default:
        return state
    }
  }
  
  export default commonDataReducer
  